import { render, staticRenderFns } from "./XhDate.vue?vue&type=template&id=2b9e79de&scoped=true&"
import script from "./XhDate.vue?vue&type=script&lang=js&"
export * from "./XhDate.vue?vue&type=script&lang=js&"
import style0 from "./XhDate.vue?vue&type=style&index=0&id=2b9e79de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e79de",
  null
  
)

component.options.__file = "XhDate.vue"
export default component.exports